import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/exams/searchbar";
import ExamsTable from "../../../containers/admin/exams/table";
import AddExamData from "../../../containers/admin/exams/models/add-exam-data";
import {
  getAllExamsRequest,
  getAllExamsSuperAdminRequest,
} from "../../../modules/admin-modules/exams/Actions";
import Questions from "../../../containers/admin/exams/models/questions";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";

const Exams = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const exams = useSelector((state) => state.exams.exams);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const userData = useSelector((state) => state.user.userData);
  const [examData, setExamData] = useState({});
  const [selectedSectionIds, setSelectedSectionIds] = useState([]);

  useEffect(() => {
    if (userData?.role?.length > 0) {
      const roleName = userData?.role[0]?.name;
      if (roleName == "Teacher" || roleName == "Assistant") {
        dispatch(getAllExamsRequest());
      } else {
        dispatch(getAllExamsSuperAdminRequest());
      }
    }
    dispatch(getAllAdminSectionsRequest());
  }, [userData]);

  const filteredExams = useMemo(() => {
    if (!selectedSectionIds.length) return exams;

    return exams?.filter((exam) =>
      exam?.chapters?.some((chapter) =>
        selectedSectionIds.some(
          (sectionId) => String(sectionId) === String(chapter?.section_id)
        )
      )
    );
  }, [exams, selectedSectionIds]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        selectedSectionIds={selectedSectionIds}
        setSelectedSectionIds={setSelectedSectionIds}
        examCount={filteredExams?.length ?? 0}
      />
      <AddExamData
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setExamData={setExamData}
      />
      <ExamsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        exams={filteredExams}
      />
      <Questions
        examData={examData}
        selectedData={selectedData}
        isAdd={isAdd}
      />
    </Layout>
  );
};

export default Exams;
